import Vue from 'vue'

/**
 *
 * @param data
 * @returns {*}
 */
export function getDiscountsList(data) {
    return Vue.axios({
        url: '/api/order/rebate_config_option',
        method: 'get',
        params: {...data}
    })
}

//保存折扣信息
export function saveDiscountsData(data) {
    return Vue.axios({
        url: '/api/order/save_rebate_config',
        method: 'post',
        data: {...data}
    })
}

//删除折扣信息
export function delectDiscountsData(data) {
    return Vue.axios({
        url: '/api/order/delete_rebate_config',
        method: 'post',
        data: {...data}
    })
}

